import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Card, Switch, Space, Collapse, Spin, Button, Table, Tag } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useParams, Link } from 'react-router-dom';
import { getApiDocs, updatePrivacyApiDocs } from '../../../apis/apiDocs';
import { getServiceDetail, updateServicePrivacy, updateServicePublicDomain } from '../../../apis/services';
import { formatServerDate } from '../../../utils/date';
import AdminLayoutWrapper from '../AdminLayoutWrapper';
import EditInput from '../../common/EditInput';

const { Panel } = Collapse;

const ServiceEntryDetail = () => {

  const [serviceDetail, setDetail] = useState({});
  const [docList, setDocList] = useState([]);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  const { id } = useParams();

  const fetchApiDocs = async (id) => {
    try {
      const docListRes = await getApiDocs(id);
      setDocList(docListRes);
    } catch (error) {
      console.log(error);
    }
  }

  const fetchServiceDetail = useCallback(async () => {
    try {
      if (id ?? false) {
        setLoading(true);
        const servieDetailRes = await getServiceDetail(id);
        await fetchApiDocs(id);
        setDetail(servieDetailRes);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [id])

  useEffect(() => {
    fetchServiceDetail();
  }, [fetchServiceDetail]);

  const updateScope = async (nextValue, group, targetId) => {
    try {
      setLoading(true);

      if (group === 'service-entries') {
        const resp = await updateServicePrivacy(id, {
          public: nextValue
        });
        await fetchApiDocs(id);
        setDetail({
          ...serviceDetail,
          ...resp,
        })
      } else if (group === 'api-docs') {
        await updatePrivacyApiDocs(targetId, {
          public: nextValue,
        });
        const nextDocList = docList.map((doc) => {
          if (parseInt(doc.id) === parseInt(targetId)) {
            return {
              ...doc,
              public: nextValue,
            }
          }
          return doc;
        });
        setDocList(nextDocList);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  const validateDomain = (value) => {
    /**
     * regex check url
     * 1. must start with http or https 
     * 2. then follow by ://
     * 3. after that is www or not
     * 4. then followed by subdomain of length (2, 256) and
     * last part contains top level domain like .com, .org etc.
     */
    const regex = /(http(s)?):\/\/(www.)?[a-zA-Z0-9@:%._\\+-~#?&/=]{2,256}\.[a-z]{2,6}\b([a-zA-Z0-9@:%._\\+-~#?&/=]*)/
    if (!regex.test(value)) {
      return {
        isValid: false,
        message: 'Public Domain is not valid url !'
      }
    }
    return {
      isValid: true,
      message: ''
    }
  }

  const handleSubmitDomain = async () => {
    console.log(inputRef?.current?.state?.value);
    try {
      setLoading(true);
      const resp = await updateServicePublicDomain(serviceDetail.id, {
        public_domain: inputRef?.current?.state?.value || serviceDetail.publicDomain
      });
      console.log(resp);
      setDetail((prev) => {
        return {
          ...prev,
          publicDomain: resp.publicDomain || inputRef?.current?.state?.value
        }
      });
      setLoading(false);
      // call api get detail 
      await fetchServiceDetail();
    } catch (error) {
      console.log('error', error);
    }
  }

  const columns = [
    {
      title: 'Api Docs Name',
      dataIndex: 'name',
      key: 'name',
      render: (value, record) => {
        return <Link to={`/admin/api-docs/${record.id}`}>{value}</Link>
      }
    },
    {
      title: 'Description',
      dataIndex: 'title',
      key: 'description',
      render: (value) => {
        return <div>{value}</div>
      }
    },
    {
      title: 'Status',
      dataIndex: 'public',
      key: 'public',
      render: (value, row) => {
        return (
          <Switch
            checkedChildren="Public"
            unCheckedChildren="Private"
            defaultChecked={false}
            checked={value}
            onChange={(checked) => {
              updateScope(checked, 'api-docs', row.id)
            }}
          />
        )
      }
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (value, record) => {
        return <Link to={`/admin/api-docs/${record.id}`}><Button type="primary">Detail</Button></Link>
      }
    }
  ];

  return (
    <AdminLayoutWrapper>
      <Spin spinning={loading}>
        <div>
          <Button type="primary" size="large">
            <Link to="/admin/services"><ArrowLeftOutlined /> Back</Link>
          </Button>
        </div>
        <br></br>
        <div>
          {
            serviceDetail?.name &&
            (<div>
              <Card title={serviceDetail.name}>
                <div>
                  <Space>
                    <p>Status:</p>
                    <p>
                      <Switch
                        checkedChildren="Public"
                        unCheckedChildren="Private"
                        defaultChecked={false}
                        checked={serviceDetail.public}
                        onChange={(checked) => {
                          updateScope(checked, 'service-entries')
                        }}
                      />
                    </p>
                  </Space>
                </div>
                <div>
                  <EditInput
                    // labelStyle={styles.primaryLabel}
                    // contentStyle={styles.secondLabel}
                    inputRef={inputRef}
                    onSubmit={handleSubmitDomain}
                    value={serviceDetail.publicDomain}
                    labelValue="Public Domain : "
                    handleValidate={validateDomain}
                    tooltipMessage="Domain must contain http:// or https://. Example: http://example.com"
                  />
                </div>
                <div>
                  <Space>
                    <p>Description:</p>
                    <p>
                      {serviceDetail.description}
                    </p>
                  </Space>
                </div>
                <div>
                  <Space>
                    <p>Updated At:</p>
                    <p>
                      {serviceDetail.updated ? formatServerDate(serviceDetail.updated / 1000) : ''}
                    </p>
                  </Space>
                </div>
              </Card>
            </div>)
          }
        </div>
        <Card title="All Api Docs">
          <div>
            <Table
              columns={columns}
              dataSource={docList}
            />
          </div>
        </Card>
      </Spin>
    </AdminLayoutWrapper>
  )
}

export default ServiceEntryDetail;